module.exports = __webpack_public_path__ + "static/img/contact-infinity.b588a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/contact-infinity.png
// module id = 88
// module chunks = 0